module.exports = __webpack_public_path__ + "static/presentations_sprite-mob-38c9758d46b788cdd3f82cf8a6b111e1.png";